import LabServiceModel from "@/models/LabServiceModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import TestPackageCollection from "@/collections/lab/TestPackageCollection";

export default class TestPackageGroupModel extends LabServiceModel {
  modelName() {
    return 'test-package-group';
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      sample_type_id: null,
      sample_type: null,
      name: null,
      description: null,
      position: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      test_packages: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      laboratory_id: (val) => (this.nullStringMutator(val)),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      position: Number,
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, 'laboratory');
  }
  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }
  getTestPackages() {
    return this.getRelatedCollection(new TestPackageCollection(), 'test_packages');
  }
}
